import { AxiosError } from "axios";
import axiosInstance from "src/config/axios";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { FundWalletCallbackResponse, PaymentAccountInfo } from "./wallet.type";

export const useFundWalletCallbackMutation = (
  txnRef: string,
  txnId: string
) => {
  const { data, trigger, isMutating, error } = useSWRMutation<
    FundWalletCallbackResponse,
    AxiosError,
    string,
    any,
    any
  >(`/comp/fundWalletCallback/${txnRef}/${txnId}`, (url: string, { arg }) =>
    axiosInstance.get(url).then((res) => res.data)
  );

  return {
    data,
    isLoading: isMutating,
    getWalletPaymentStatus: trigger,
  };
};

export const useFundWalletMutation = (talentId: string) => {
  const { data, trigger, isMutating, error } = useSWRMutation<
    any,
    AxiosError,
    string,
    any,
    any
  >(`/comp/fundWallet/${talentId}`, (url: string, { arg }) =>
    axiosInstance.post(url, arg).then((res) => res.data)
  );

  return {
    data,
    isLoading: isMutating,
    fundWallet: trigger,
  };
};

export const useCashbackConversionMutation = () => {
  const { data, trigger, isMutating, error } = useSWRMutation<
    any,
    AxiosError,
    string,
    any,
    any
  >(`/comp/fundWallet`, (url: string, { arg }) =>
    axiosInstance.put(url, arg).then((res) => res.data)
  );

  return {
    data,
    isLoading: isMutating,
    convertCashback: trigger,
  };
};

export const useTransactionsQuery = (page: number, pageSize: number) => {
  const { data, error, isLoading, mutate } = useSWR<
    any,
    AxiosError,
    [string, string]
  >(
    ["/all/getAllMyTransactions", `?page=${page + 1}&limit=${pageSize}`],
    ([url, queryParams]) =>
      axiosInstance.get(url + (queryParams || "")).then((res) => res.data.data)
  );

  return {
    transactions: data,
    isLoading,
    error,
    getTransactions: mutate,
  };
};

export const useTransactionsDetailsQuery = (id: string) => {
  const { data, error, isLoading, mutate } = useSWR<any, AxiosError, string>(
    `/all/getTransactionDetail/${id}`,
    (url: string) => axiosInstance.get(url).then((res) => res.data?.data)
  );

  return {
    transaction: data,
    isLoading,
    error,
    getTransaction: mutate,
  };
};

export const useConvertCashbackMutation = () => {
  const { data, trigger, isMutating, error } = useSWRMutation<
    any,
    AxiosError,
    string,
    any,
    any
  >(`/all/convertCashback`, (url: string, { arg }) =>
    axiosInstance.put(url, arg).then((res) => res.data)
  );

  return {
    data,
    isLoading: isMutating,
    convertCashback: trigger,
  };
};

export const usePayViaWalletMutation = () => {
  const { data, trigger, isMutating, error } = useSWRMutation<
    any,
    AxiosError,
    string,
    any,
    any
  >(`/comp/payViaWallet`, (url: string, { arg }) =>
    axiosInstance.post(url, arg).then((res) => res.data)
  );

  return {
    data,
    isLoading: isMutating,
    payViaWallet: trigger,
  };
};

// export const useGetPaymentAccountInfo = (
// jobId: string, type: string, paymentPlan?: string , amount?: string, projectId?: string,
// ) => {
//   const { data, error, isLoading, mutate } = useSWR<
//     PaymentAccountInfo,
//     AxiosError,
//     string
//   >(
//     `/all/getPaymentAccountInfo?jobId=${jobId}&type=${type}&paymentPlan=${paymentPlan}&amount=${amount}&projectId=${projectId}`,
//     (url: string) => axiosInstance.get(url).then((res) => res.data?.data),
//     {
//       revalidateOnMount: true,
//       revalidateOnFocus: false,
//       revalidateOnReconnect: false,
//       revalidateIfStale: false
//     }
//   );

//   return {
//     paymentAccountInfo: data,
//     isLoading,
//     error,
//     getPaymentAccountInfo: mutate,
//   };
// };


export const useGetPaymentAccountInfo = (
  jobId: string,
  type: string,
  paymentPlan?: string,
  amount?: string,
  projectId?: string,
  subscriptionType?: string
) => {

  const params = new URLSearchParams()

  if (jobId) params.append("jobId", jobId)
  if (type) params.append("type", type)
  if (paymentPlan) params.append("paymentPlan", paymentPlan)
  if (amount) params.append("amount", amount)
  if (subscriptionType) params.append("subscription_type", subscriptionType)


  if (projectId && projectId !== "null" && projectId !== "undefined") {
    params.append("projectId", projectId)
  }

  const url = `/all/getPaymentAccountInfo?${params.toString()}`

  const { data, error, isLoading, mutate } = useSWR(
    url,
    (url: string) => axiosInstance.get(url).then(res => res.data?.data),
    {
      revalidateOnMount: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  )

  return { paymentAccountInfo:data, error, isLoading, mutate }
}